/**
 * Человекочитаемое имя файла из URL в message_content (документы и т.п.):
 * decodeURIComponent, попытка починить UTF-8, показанный как Latin-1 (mojibake),
 * снятие префикса timestamp от сервера.
 * Предпочтительно message_length (транслит / сохранённое имя).
 */

function tryFixUtf8Mojibake(s: string): string {
  if (!s) return s;
  if (/[\u0400-\u04FF]/.test(s)) return s;
  if (!/[À-ÿ\u00C0-\u024F]/.test(s)) return s;
  try {
    const bytes = new Uint8Array(s.length);
    for (let i = 0; i < s.length; i++) bytes[i] = s.charCodeAt(i) & 0xff;
    const decoded = new TextDecoder('utf-8', { fatal: false }).decode(bytes);
    const cyr = (decoded.match(/[\u0400-\u04FF]/g) || []).length;
    if (cyr >= 2) return decoded.replace(/\uFFFD/g, '_');
  } catch {
    /* ignore */
  }
  return s;
}

function isOpaqueHashFilename(name: string): boolean {
  const base = name.replace(/\.[^.]+$/, '');
  return /^[a-f0-9]{32}$/i.test(base);
}

function friendlyOpaqueName(name: string): string {
  const dot = name.lastIndexOf('.');
  const ext = dot > 0 ? name.slice(dot) : '';
  return `Document${ext}`;
}

/**
 * @param contentUrl — message_content (uploads/… или lyke/…)
 * @param preferredName — message_length, если сервер сохранил читаемое имя
 */
export function displayStoredUploadFilename(
  contentUrl: string | undefined | null,
  preferredName?: string | null,
): string {
  const preferred = (preferredName || '').trim();
  if (preferred && !isOpaqueHashFilename(preferred)) {
    return tryFixUtf8Mojibake(preferred.replace(/^\d{10,}(?:-\d+)?-/, ''));
  }

  if (!contentUrl) return preferred || '';
  try {
    const segment = (contentUrl.replace(/\\/g, '/').split('/').pop() || '').trim();
    let name = segment;
    try {
      name = decodeURIComponent(segment.replace(/\+/g, ' '));
    } catch {
      name = segment;
    }
    name = tryFixUtf8Mojibake(name);
    name = name.replace(/^\d{10,}(?:-\d+)?-/, '');
    if (isOpaqueHashFilename(name)) {
      return friendlyOpaqueName(name);
    }
    return name;
  } catch {
    return preferred || '';
  }
}
